/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Server_Errors_Unexpectederror1Inputs */

const he_server_errors_unexpectederror1 = /** @type {(inputs: Server_Errors_Unexpectederror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אירעה שגיאה בלתי צפויה`)
};

const en_server_errors_unexpectederror1 = /** @type {(inputs: Server_Errors_Unexpectederror1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An unexpected error occurred`)
};

/**
* | output |
* | --- |
* | "An unexpected error occurred" |
*
* @param {Server_Errors_Unexpectederror1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const server_errors_unexpectederror1 = /** @type {((inputs?: Server_Errors_Unexpectederror1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Server_Errors_Unexpectederror1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_server_errors_unexpectederror1(inputs)
	return en_server_errors_unexpectederror1(inputs)
});
export { server_errors_unexpectederror1 as "server_errors_unexpectedError" }